<template>
  <el-dialog :id="$options.name" :before-close="noDialog"
             :fullscreen="dialogFullscreen" :visible.sync="dialog"
             title="新建包月模板"
  >
    <el-form ref="params" :model="params" :rules="rules" label-width="auto">
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="params.name" placeholder="请输入模板名称"/>
      </el-form-item>
      <div v-for="(item,index) in params.monthlyInfoList" :key="index">
        <el-form-item label="价格详细">
          <el-row>
            <el-col :span="4" :xs="12">
              <el-form-item :prop="'monthlyInfoList.'+index+'.money'" :rules="rules.money">
                <el-input v-model="item.money" maxlength="4">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4" :xs="12">
              <el-form-item :prop="'monthlyInfoList.'+index+'.freeDayNum'" :rules="rules.day">
                <el-input v-model.number="item.freeDayNum" maxlength="3">
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="4" :xs="12" class="xs-m-p">
              <el-form-item :prop="'monthlyInfoList.'+index+'.freeChargeNum'" :rules="rules.chi">
                <el-input v-model.number="item.freeChargeNum" maxlength="3">
                  <template slot="append">小时</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" :xs="10" class="xs-m-p">
              <el-form-item :prop="'monthlyInfoList.'+index+'.startPower'" :rules="rules.startPower">
                <el-input v-model.number="item.startPower" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="1" :xs="2" class="t-c xs-m-p">
              到
            </el-col>
            <el-col :span="4" :xs="12" class="xs-m-p">
              <el-form-item :prop="'monthlyInfoList.'+index+'.endPower'" :rules="rules.endPower">
                <el-input v-model.number="item.endPower" maxlength="4">
                  <template slot="append">瓦</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" :xs="6" class="xs-m-p">
              <el-button v-if="listStart(index)" type="primary" @click="addItem(item)">
                新增
              </el-button>
            </el-col>
            <el-col :span="2" :xs="6" class="xs-m-p">
              <el-button v-if="listEnd(index)" type="danger"
                         @click="removeItem(item,params.monthlyInfoList)">
                删除
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="addPost">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import monthlyTemplateAdd from "@/api/device/monthly-template-manage/monthlyTemplateAdd";
import monthlyTemplateMixin from "@/mixin/monthlyTemplateMixin/monthlyTemplateMixin";

export default {
  name: "addMonthlyTemplate",
  mixins: [monthlyTemplateMixin],
  watch: {
    dialog(newValue) {
      if (newValue === true) {
        this.params = {
          name: undefined,
          monthlyInfoList: [{
            startPower: 0,
            endPower: undefined,
            freeChargeNum: undefined,
            freeDayNum: undefined,
            money: undefined,
          }]
        },
            this.$nextTick(() => {
              this.$refs['params'].clearValidate();
            })
      }
    }
  },
  methods: {
    addPost() {
      this.$refs['params'].validate((valid) => {
        if (valid) {
          this.loadStart();
          monthlyTemplateAdd(this.params).then(res => {
            this.resEditNoDialog({res})
          }).finally(() => {
            this.loadDialog.close();
          })
        }
      });
    },
  }
}
</script>
